import styled from "@emotion/styled";
import { alpha } from "@mui/material";
import { DataGrid, gridClasses } from "@mui/x-data-grid";


export const StyledDataGrid = styled(DataGrid)(({theme}) => ({
    '& .MuiDataGrid-row': {
        cursor: 'pointer',
    },
    '& .MuiDataGrid-cell': {
        // color: '#ff0000',
    },
    '& .MuiDataGrid-columnHeader': {
        borderBottom: '6px solid transparent',
        '&.status-new': {
            background: theme.palette.statusIdle.main,
        },
        '&.status-desktop, &.status-desktop-qa': {
            borderBottomColor: theme.palette.statusActive.main,
        },
        '&.status-field, &.status-field-qa': {
            borderBottomColor: theme.palette.statusComplete.main,
        },
        '&.status-remedial': {
            borderBottomColor: theme.palette.statusPaused.main,
        },
        '&.status-fsp': {
            borderBottomColor: theme.palette.info.main,
        },
        '&.status-eliminated, &.status-eliminated-ug': {
            borderBottomColor: theme.palette.statusPending.main,
        },
    },
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.secondary.main, 0.2),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
    },
}));
